import dayjs, { dateDisplayFormat } from '~libs/dayjs';

import { Column } from '~components/table-view';

const columns: Column[] = [
  {
    id: 'reference',
    header: 'Reference',
    type: 'text',
  },
  {
    id: 'full_name',
    header: 'Client Name',
    type: 'text',
    deriveValue: (row) => row.client?.full_name,
  },
  {
    id: 'dates',
    header: 'Budget Dates',
    type: 'text',
    deriveValue: (row: any) => {
      const startDate = row.start_date ? dayjs(row.start_date).format(dateDisplayFormat) : 'N/A';
      const endDate = row.end_date ? dayjs(row.end_date).format(dateDisplayFormat) : 'N/A';
      return `${startDate} - ${endDate}`;
    },
  },
  {
    id: 'status',
    header: 'Status',
    type: 'text',
    deriveValue: (row) => row.status?.name,
  },
  {
    id: 'package',
    header: 'Package',
    type: 'text',
    deriveValue: (row) => row.package_fixed?.name,
  },
  {
    id: 'funding_type',
    header: 'Funding Type',
    type: 'text',
    deriveValue: (row) => row.package_fixed?.funding_type?.name,
  },
];

export default columns;
